// eslint-disable-next-line import/no-cycle
import me from '../modules/me/me.resolvers';
import screenSize from '../modules/screenSize/screenSize.resolvers';

const resolvers = {
    Mutation: {
        screenSize,
    },
    Query: {
        me,
    },
};

export default resolvers;
